<h1 mat-dialog-title>{{mDialogTitle | translate}}</h1>
<div mat-dialog-content>
  <p>{{mDialogInformation | translate}}</p>
  <p>{{mDialogInformation2 | translate}}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onYesClick()">{{'Oui' | translate}}</button>
  <button mat-raised-button (click)="onNoClick()">{{'Non' | translate}}</button>
  <button mat-raised-button [mat-dialog-close] cdkFocusInitial>{{'Annuler' | translate}}</button>
</div>
